module.exports = __webpack_public_path__ + "img/Weapon_239.d9524c70.png";